import JobSeriesList from "./JobSeriesList/JobSeriesList"

const List = JobSeriesList

export default { List }
